import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { mutationUpdateCustomerFieldType } from "Apollo";
import { ShowNotice } from "Store";
import Icon from "module-common/Icon";
import Input from "module-common/Input";
import DeleteButton from "./DeleteButtonWithMutation";

export default graphql(mutationUpdateCustomerFieldType)(
  class Row extends Component {
    static propTypes = {
      id: PropTypes.number,
      index: PropTypes.number,
      field: PropTypes.string
    };
    state = { editing: false, newName: "" };

    render() {
      const { id, index, field } = this.props;
      const { editing, newName } = this.state;
      return (
        <Wrapper>
          <Index>{index}.</Index>
          {editing ? (
            <form onSubmit={this.onEditClick}>
              <InputField
                value={newName}
                onChange={e => this.setState({ newName: e.target.value })}
              />
            </form>
          ) : (
            <Field>{field}</Field>
          )}
          <IconEdit name="edit" onClick={this.onEditClick} />
          <DeleteButton id={id} />
        </Wrapper>
      );
    }

    onEditClick = () => {
      const editing = this.state.editing;
      if (editing) {
        // submit
        this.onUpdate();
        this.setState({ editing: false });
      } else {
        this.setState({ editing: true, newName: this.props.field });
      }
    };

    onUpdate = () => {
      try {
        this.props.mutate({
          variables: {
            customerFieldTypeInput: {
              id: this.props.id,
              displayName: this.state.newName
            }
          }
        });
        ShowNotice("customer-field-template-update-success");
      } catch (error) {
        ShowNotice("customer-field-template-update-error");
      }
    };
  }
);

const Wrapper = styled.div`
  width: 270px;
  height: 35px;
  display: flex;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  align-items: center;
`;
const Index = styled.div`
  margin-left: 10px;
  width: 25px;
  flex: none;
`;
const Field = styled.div`
  flex: 1;
`;
const IconEdit = styled(Icon)`
  margin-left: 10px;
  margin-right: 10px;
`;
const InputField = styled(Input)`
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/customer-field-panel/RowWithMutation.js